module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.c66518ca.otf";